<template>
    <div class="left-event-list">
            <div class="left-event-header">
                <h3>Select an Event</h3>
                <div class="header-action-button">
                    <v-btn outlined rounded color="#1a73e8">View all events</v-btn>
                    <v-btn @click="closeLeftPanel()" density="compact" rounded fab small><v-icon color="#333">mdi-close</v-icon></v-btn>
                </div>
            </div>
            <div class="chatgpt-event-list-wrap">
                <div v-for="i in 10" :key="i" class="gpt-single-event-list">
                    <div class="gpt-event-img">
                        <img src="../assets/Images/background-survey-starter.jpg"/>
                    </div>
                    <div class="gpt-event-name">
                        <h5>Get Started Omaha - Presented by Husch Blackwell</h5>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
export default {
    components: {
    },
    props: {
        visible: {
        type: Boolean,
        required: true
        }
    },
    data() {
        return {
        }
    },
    computed: {
        
    },
    watch: {},
    created() {},
    mounted() {},
    methods: {
        closeLeftPanel(){
            this.$parent.openLeftPanel = false; 
        }
    },

}
</script>